export const clone = <T>(entity: T): T => JSON.parse(JSON.stringify(entity));
